import { j as l } from "./jsx-runtime-DmTjM30f.js";
import { a as se, d as de, S as ie, c as j, i as ue, M as me, F as he, B as fe, b as ce, q as be } from "./index.esm-G8KyR0tM.js";
import { O as te, P as ee } from "./PurchaseOrderList-mO3KSFgi.js";
import { useContext as oe, useState as t, useEffect as I } from "react";
import { F as re } from "./provider-Diwup2pn.js";
import { i as J, k as n, E as ge, D as we, F as xe, m as _e, b as je } from "./utils-D5LKKDAj.js";
import { u as pe } from "./useConfiguration-B-lyaBB9.js";
import { r as X } from "./sentry-CAR5o4wv.js";
import { i as f } from "./index-wI714H_N.js";
import { u as Se } from "./useScrollToBottomRef-CqDzM0dm.js";
import { ErrorPage as Le } from "./ErrorPage.js";
function le({ isGroupInvestment: p, investor: b, mfInvestmentAccount: x }) {
  const { fpapi: O } = oe(re), { amcs: c, tenantConfig: g } = pe(), C = g == null ? void 0 : g.fallbackLogo, E = g == null ? void 0 : g.showSchemeLogo, [B, y] = t("initial"), [H, v] = t(!0), [M, N] = t([]), [_, V] = t([]), [w, T] = t(null), [K, R] = t(!1), [U, A] = t(null), F = Se(U), [Z, W] = t(!1), [D, z] = t(10);
  I(() => {
    Y();
  }, []), I(() => {
    F.hasScrolledToBottom && Q();
  }, [
    F.hasScrolledToBottom
  ]);
  const k = async (e) => {
    const h = [];
    for (const u of e)
      try {
        const s = await O.fpClient.master_data().fetchScheme(u), m = E ? {
          ...s,
          schemeLogo: c[s == null ? void 0 : s.amc_id] || C
        } : {
          ...s
        };
        h.push(m);
      } catch (s) {
        window.debug.error(s), X(s);
      }
    return h;
  }, Q = async () => {
    if (!(D >= _.length) && (W(!0), _.length)) {
      const e = _ == null ? void 0 : _.sort((d, o) => new Date(o == null ? void 0 : o.created_at).valueOf() - new Date(d == null ? void 0 : d.created_at).valueOf()), h = D + 10, u = e == null ? void 0 : e.slice(D, h), s = structuredClone(u);
      z(h);
      const m = /* @__PURE__ */ new Set();
      u.forEach((d) => m.add(d == null ? void 0 : d.scheme));
      let S = [];
      const L = await k(m);
      S = structuredClone(L), u.forEach((d) => {
        const o = S.find((i) => i.isin === d.scheme);
        o && (d.schemeDetails = o);
      }), T(s[0]), N((d) => d.concat(u)), W(!1);
    }
  }, Y = async () => {
    var h, u;
    if (J(x)) {
      y("no_listing"), v(!1);
      return;
    }
    v(!0);
    let e;
    try {
      e = await O.fpClient.mf_redemptions().fetchAll({
        mf_investment_account: x.id
      }), V(e == null ? void 0 : e.data);
    } catch (s) {
      window.debug.error(s), y("no_listing"), v(!1), X(s);
      return;
    }
    if ((h = e == null ? void 0 : e.data) != null && h.length) {
      const s = (u = e == null ? void 0 : e.data) == null ? void 0 : u.sort((i, r) => new Date(r == null ? void 0 : r.created_at).valueOf() - new Date(i == null ? void 0 : i.created_at).valueOf()), m = s == null ? void 0 : s.slice(0, D), S = structuredClone(m), L = /* @__PURE__ */ new Set();
      m.forEach((i) => L.add(i == null ? void 0 : i.scheme));
      let d = [];
      const o = await k(L);
      d = structuredClone(o), m.forEach((i) => {
        const r = d.find(($) => $.isin === i.scheme);
        r && (i.schemeDetails = r);
      }), T(S[0]), N(m);
    } else
      y("no_listing");
    v(!1);
  }, G = (e) => {
    T(_[e.target.value]);
  }, q = () => /* @__PURE__ */ l.jsxs(l.Fragment, {
    children: [
      M ? /* @__PURE__ */ l.jsx(de, {
        variant: "selectable",
        onChange: G,
        selected: 0,
        children: M.map((e) => {
          var h, u;
          return /* @__PURE__ */ l.jsx(ie, {
            innerRef: A,
            children: /* @__PURE__ */ l.jsxs("div", {
              className: "flex flex-wrap py-2",
              children: [
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-full",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "XTJZw8"
                    }),
                    value: J(e == null ? void 0 : e.schemeDetails) ? "-" : n((h = e == null ? void 0 : e.schemeDetails) == null ? void 0 : h.name),
                    logo: E ? c[(u = e == null ? void 0 : e.schemeDetails) == null ? void 0 : u.amc_id] || C : ""
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: e != null && e.amount ? f._({
                      id: "KqeLJ1"
                    }) : f._({
                      id: "6ssn5V"
                    }),
                    value: e != null && e.amount ? `₹ ${ge(e.amount)}` : e != null && e.units ? e == null ? void 0 : e.units : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "e7LnWq"
                    }),
                    value: e != null && e.state ? /* @__PURE__ */ l.jsx(ue, {
                      variant: "outline",
                      message: `${we(e == null ? void 0 : e.state, e == null ? void 0 : e.object)}`,
                      status: xe(e == null ? void 0 : e.state)
                    }) : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "1Jcjg6"
                    }),
                    value: e != null && e.created_at ? _e(new Date(e == null ? void 0 : e.created_at), "dd-MMM-yyyy") : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "cXcPd1"
                    }),
                    value: e != null && e.folio_number ? e == null ? void 0 : e.folio_number : "New folio"
                  })
                })
              ]
            })
          }, e == null ? void 0 : e.id);
        })
      }) : /* @__PURE__ */ l.jsx(l.Fragment, {}),
      Z ? /* @__PURE__ */ l.jsx("div", {
        className: "flex justify-center",
        children: /* @__PURE__ */ l.jsx(me, {
          type: "important",
          variant: "field",
          title: "Loading..",
          loader: !0,
          customClass: "mb-5 "
        })
      }) : /* @__PURE__ */ l.jsx(l.Fragment, {}),
      w ? /* @__PURE__ */ l.jsx(he, {
        children: /* @__PURE__ */ l.jsx(fe, {
          variant: "primary",
          fullwidth: !0,
          onClick: (e) => {
            e.preventDefault(), R(!0);
          },
          children: f._({
            id: "f9pW3a"
          })
        })
      }) : null,
      /* @__PURE__ */ l.jsx(ce, {
        variant: "fullPage",
        contentHeightMax: !0,
        title: `${je(w == null ? void 0 : w.id)} order details`,
        isOpen: K,
        toggleModal: () => {
          R(!1);
        },
        children: /* @__PURE__ */ l.jsx(te, {
          transactionId: w == null ? void 0 : w.id,
          isGroupInvestment: p,
          investor: b
        })
      })
    ]
  });
  function P() {
    switch (B) {
      default:
        return q();
      case "initial":
        return q();
      case "no_listing":
        return /* @__PURE__ */ l.jsx(Le, {
          title: f._({
            id: "Dc4+I+"
          }),
          description: f._({
            id: "TrVJ7E"
          }),
          showDetails: !1,
          showAction: !1
        });
    }
  }
  return H ? /* @__PURE__ */ l.jsx(se, {
    variant: "fullpage"
  }) : P();
}
function ve({ isGroupInvestment: p, investor: b, mfInvestmentAccount: x }) {
  const { fpapi: O } = oe(re), { amcs: c, tenantConfig: g } = pe(), C = g == null ? void 0 : g.fallbackLogo, E = g == null ? void 0 : g.showSchemeLogo, [B, y] = t("initial"), [H, v] = t(!0), [M, N] = t([]), [_, V] = t([]), [w, T] = t(null), [K, R] = t(!1), [U, A] = t(null), F = Se(U), [Z, W] = t(!1), [D, z] = t(10);
  I(() => {
    Y();
  }, []), I(() => {
    F.hasScrolledToBottom && Q();
  }, [
    F.hasScrolledToBottom
  ]);
  const k = async (e) => {
    const h = [];
    for (const u of e)
      try {
        const s = await O.fpClient.master_data().fetchScheme(u), m = E ? {
          ...s,
          schemeLogo: c[s == null ? void 0 : s.amc_id] || C
        } : {
          ...s
        };
        h.push(m);
      } catch (s) {
        window.debug.error(s), X(s);
      }
    return h;
  }, Q = async () => {
    if (!(D >= _.length) && (W(!0), _.length)) {
      const e = _.sort((d, o) => new Date(o == null ? void 0 : o.created_at).valueOf() - new Date(d == null ? void 0 : d.created_at).valueOf()), h = D + 10, u = e == null ? void 0 : e.slice(D, h), s = structuredClone(u);
      z(h);
      const m = /* @__PURE__ */ new Set();
      u.forEach((d) => m.add(d == null ? void 0 : d.switch_in_scheme)), u.forEach((d) => m.add(d == null ? void 0 : d.switch_out_scheme));
      let S = [];
      const L = await k(m);
      S = structuredClone(L), u.forEach((d) => {
        const o = S.find((r) => r.isin === d.switch_in_scheme), i = S.find((r) => r.isin === d.switch_out_scheme);
        o && (d.schemeDetails = o), i && (d.switchOutSchemeDetails = i);
      }), T(s[0]), N((d) => d.concat(u)), W(!1);
    }
  }, Y = async () => {
    var h, u;
    if (J(x)) {
      y("no_listing"), v(!1);
      return;
    }
    v(!0);
    let e;
    try {
      e = await O.fpClient.mf_switches().fetchAll({
        mf_investment_account: x.id
      }), V(e == null ? void 0 : e.data);
    } catch (s) {
      window.debug.error(s), y("no_listing"), v(!1), X(s);
      return;
    }
    if ((h = e == null ? void 0 : e.data) != null && h.length) {
      const s = (u = e == null ? void 0 : e.data) == null ? void 0 : u.sort((i, r) => new Date(r == null ? void 0 : r.created_at).valueOf() - new Date(i == null ? void 0 : i.created_at).valueOf()), m = s == null ? void 0 : s.slice(0, D), S = structuredClone(m), L = /* @__PURE__ */ new Set();
      m.forEach((i) => L.add(i == null ? void 0 : i.switch_in_scheme)), m.forEach((i) => L.add(i == null ? void 0 : i.switch_out_scheme));
      let d = [];
      const o = await k(L);
      d = structuredClone(o), m.forEach((i) => {
        const r = d.find((a) => a.isin === i.switch_in_scheme), $ = d.find((a) => a.isin === i.switch_out_scheme);
        r && (i.schemeDetails = r), $ && (i.switchOutSchemeDetails = $);
      }), T(S[0]), N(m);
    } else
      y("no_listing");
    v(!1);
  }, G = (e) => {
    T(_[e.target.value]);
  }, q = () => /* @__PURE__ */ l.jsxs(l.Fragment, {
    children: [
      M.length ? /* @__PURE__ */ l.jsx(de, {
        variant: "selectable",
        onChange: G,
        selected: 0,
        children: M.map((e) => {
          var h, u, s, m;
          return /* @__PURE__ */ l.jsx(ie, {
            innerRef: A,
            children: /* @__PURE__ */ l.jsxs("div", {
              className: "flex flex-wrap py-2",
              children: [
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-full",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "6Xqu8f"
                    }),
                    value: J(e == null ? void 0 : e.switchOutSchemeDetails) ? "-" : n((h = e == null ? void 0 : e.switchOutSchemeDetails) == null ? void 0 : h.name),
                    logo: E ? c[(u = e == null ? void 0 : e.switchOutSchemeDetails) == null ? void 0 : u.amc_id] || C : ""
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-full",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "qAf0Wv"
                    }),
                    value: J(e == null ? void 0 : e.schemeDetails) ? "-" : n((s = e == null ? void 0 : e.schemeDetails) == null ? void 0 : s.name),
                    logo: E ? c[(m = e == null ? void 0 : e.schemeDetails) == null ? void 0 : m.amc_id] || C : ""
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: e != null && e.amount ? f._({
                      id: "KqeLJ1"
                    }) : f._({
                      id: "6ssn5V"
                    }),
                    value: e != null && e.amount ? `₹ ${ge(e == null ? void 0 : e.amount)}` : e != null && e.units ? e == null ? void 0 : e.units : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "e7LnWq"
                    }),
                    value: e != null && e.state ? /* @__PURE__ */ l.jsx(ue, {
                      variant: "outline",
                      message: `${we(e == null ? void 0 : e.state, e == null ? void 0 : e.object)}`,
                      status: xe(e == null ? void 0 : e.state)
                    }) : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "lJ+6AR"
                    }),
                    value: e != null && e.created_at ? _e(new Date(e == null ? void 0 : e.created_at), "dd-MMM-yyyy") : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(j, {
                    label: f._({
                      id: "cXcPd1"
                    }),
                    value: e != null && e.folio_number ? e == null ? void 0 : e.folio_number : "New folio"
                  })
                })
              ]
            })
          }, e == null ? void 0 : e.id);
        })
      }) : /* @__PURE__ */ l.jsx(l.Fragment, {}),
      Z ? /* @__PURE__ */ l.jsx("div", {
        className: "flex justify-center",
        children: /* @__PURE__ */ l.jsx(me, {
          type: "important",
          variant: "field",
          title: "Loading..",
          loader: !0,
          customClass: "mb-5 "
        })
      }) : /* @__PURE__ */ l.jsx(l.Fragment, {}),
      w ? /* @__PURE__ */ l.jsx(he, {
        children: /* @__PURE__ */ l.jsx(fe, {
          variant: "primary",
          fullwidth: !0,
          onClick: (e) => {
            e.preventDefault(), R(!0);
          },
          children: f._({
            id: "f9pW3a"
          })
        })
      }) : null,
      /* @__PURE__ */ l.jsx(ce, {
        variant: "fullPage",
        contentHeightMax: !0,
        title: `${je(w == null ? void 0 : w.id)} order details`,
        isOpen: K,
        toggleModal: () => {
          R(!1);
        },
        children: /* @__PURE__ */ l.jsx(te, {
          transactionId: w == null ? void 0 : w.id,
          isGroupInvestment: p,
          investor: b
        })
      })
    ]
  });
  function P() {
    switch (B) {
      default:
        return q();
      case "initial":
        return q();
      case "no_listing":
        return /* @__PURE__ */ l.jsx(Le, {
          title: f._({
            id: "tw7tew"
          }),
          description: f._({
            id: "Dsmjl5"
          }),
          showDetails: !1,
          showAction: !1
        });
    }
  }
  return H ? /* @__PURE__ */ l.jsx(se, {
    variant: "fullpage"
  }) : P();
}
function ke({ isGroupInvestment: p, investorProfile: b, mfInvestmentAccount: x, isPartner: O, searchParams: c }) {
  const g = {
    purchase: {
      title: "Purchase",
      content: /* @__PURE__ */ l.jsx(ee, {
        isGroupInvestment: p,
        investor: b,
        mfInvestmentAccount: x,
        isPartner: O,
        searchParams: c
      })
    },
    withdraw: {
      title: "Withdrawal",
      content: /* @__PURE__ */ l.jsx(le, {
        isGroupInvestment: p,
        investor: b,
        mfInvestmentAccount: x,
        searchParams: c
      })
    },
    switch: {
      title: "Switch",
      content: /* @__PURE__ */ l.jsx(ve, {
        isGroupInvestment: p,
        investor: b,
        mfInvestmentAccount: x,
        searchParams: c
      })
    }
  };
  return /* @__PURE__ */ l.jsx(be, {
    selected: 0,
    group: p ? [
      {
        title: "Purchase",
        content: /* @__PURE__ */ l.jsx(ee, {
          isGroupInvestment: p,
          investor: b,
          mfInvestmentAccount: x,
          searchParams: c
        })
      },
      {
        title: "Withdrawal",
        content: /* @__PURE__ */ l.jsx(le, {
          isGroupInvestment: p,
          investor: b,
          mfInvestmentAccount: x,
          searchParams: c
        })
      }
    ] : c != null && c.type ? [
      g[c == null ? void 0 : c.type]
    ] : Object.values(g)
  });
}
export {
  ke as O
};
